import React, { Fragment, useEffect, useState } from "react";
import SearchItem from "./SearchItem";
import MapViewController from "./MapViewController";
import { useDispatch, useSelector } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars-with-mac-support";
import Map from "./Map";
import Loader from "./Loader";
import useCustomloadapi from "../hooks/use-scriptload";
import { useTranslation } from "react-i18next";
import ScrollToTop from "./ScrollToTop";
const getScreenWidth = () => {
  return window.innerWidth;
};
const Searchresult = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "searchResult" });
  const rearchresults = useSelector((index) => index.rearchresults);
  const isPogress = useSelector((index) => index.isPogress);
  const [resultObj, setResultObj] = useState([]);
  const ismaploaded = true;
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [mapVisibility, setMapVisibility] = useState(false);
  const displaystatus = useSelector((index) => index.displaystatus);
  const [activeItem, setActiveItem] = useState({});
  const mapController = (val) => {
    setMapVisibility(val);
  };
  const [scrollfromTop, setScrollfromTop] = useState(0);
  //console.log("map visible:", mapVisibility);
  useEffect(() => {
    //useLoadScript();
    //console.log(rearchresults);
    setResultObj(rearchresults);
    function handleResize() {
      setScreenWidth(getScreenWidth());
      if (window.innerWidth > 991.98) {
        setMapVisibility(false);
      }
    }
    window.addEventListener("resize", handleResize);
  }, [rearchresults]);

  useEffect(() => {
    // map position fixed when scroll in mobile
    window.addEventListener("scroll", function () {
      if (
        document.querySelector(".show-device-map") !== null &&
        getScreenWidth() < 992
      ) {
        if (
          window.pageYOffset > 0 &&
          document
            .querySelector(".show-device-map")
            .classList.contains("position-fixed") === false
        ) {
          document
            .querySelector(".show-device-map")
            .classList.add("position-fixed");
          const mapPositionSet = setInterval(() => {
            document
              .querySelector(".show-device-map")
              .style.setProperty(
                "top",
                document.querySelector("#main-header").clientHeight +
                  document.querySelector(".app-header").clientHeight +
                  13 +
                  "px"
              );
          }, 1);
          setTimeout(() => {
            clearInterval(mapPositionSet);
          }, 500);
          document
            .querySelector(".show-device-map")
            .style.setProperty("left", "0");
          document
            .querySelector(".show-device-map")
            .style.setProperty("top", "0");
          document
            .querySelector(".show-device-map")
            .style.setProperty("right", "0");
          document
            .querySelector(".show-device-map")
            .style.setProperty("bottom", "0");
          document
            .querySelector(".show-device-map")
            .style.setProperty("z-index", "9");
        } else if (
          window.pageYOffset < 1 &&
          getScreenWidth() < 992 &&
          document
            .querySelector(".show-device-map")
            .classList.contains("position-fixed")
        ) {
          document
            .querySelector(".show-device-map")
            .classList.remove("position-fixed");
          document.querySelector(".show-device-map").style.cssText =
            "left:" +
            null +
            "; right:" +
            null +
            "; bottom:" +
            null +
            "; top:" +
            null +
            "; z-index:" +
            null +
            "";
        }
      }
    });
    let pageScrolled = false;
    // body padding based on animating header height
    window.addEventListener("scroll", function () {
      if (window.scrollY < 1) {
        const setBodyPadding = setInterval(() => {
          document.querySelector("#main").style.paddingTop =
            document.querySelector("#main-header").clientHeight +
            document.querySelector("#main-header .bottom-nav-wrapper")
              .clientHeight +
            "px";
        }, 1);
        setTimeout(() => {
          clearInterval(setBodyPadding);
        }, 500);
        pageScrolled = false;
      }

      // search header position adjust on mobile
      if (window.scrollY > 0 && getScreenWidth() < 992 && !pageScrolled) {
        pageScrolled = true;
        setTimeout(() => {
          document.querySelector(".app-header-wrapper").style.top =
            document.querySelector("#main-header").clientHeight - 1 + "px";
        }, 500);
      }
    });
  }, []);
  useEffect(() => {
    // Header menu / Header horizontal menu disable on scroll above 0 window scroll.
    const headerMenuRemover = setTimeout(() => {
      if (window.scrollY > 0) {
        document
          .querySelector("#main-header .bottom-nav-wrapper")
          .classList.add("hide-for-search");
      } else {
        document
          .querySelector("#main-header .bottom-nav-wrapper")
          .classList.remove("hide-for-search");
      }
    }, 40);
    return () => {
      clearTimeout(headerMenuRemover);
    };
  }, [scrollfromTop]);

  useEffect(() => {
    // Header menu / Header horizontal menu disable resetter when move to other pages / Compoent will unmount.
    return () => {
      document
        .querySelector("#main-header .bottom-nav-wrapper")
        .classList.remove("hide-for-search");
    };
  }, []);
  window.addEventListener("scroll", function () {
    setScrollfromTop(window.scrollY);
  });

  const scrollToEl = (id) => {
    //console.log(id);
    const scrollToElMobile = () => {
      window.scrollTo(
        0,
        document.querySelector("#" + id).getBoundingClientRect().top +
          window.scrollY -
          (document.querySelector("#main-header").clientHeight +
            document.querySelector(".app-header").clientHeight +
            14 +
            document.querySelector(".show-device-map").clientHeight)
      );
    };
    if (getScreenWidth() > 991.98) {
      const smoothScroll = () => {
        setTimeout(() => {
          document.querySelector(".scroll-panel").style.scrollBehavior = "";
        }, 1000);
      };
      document.querySelector(".scroll-panel").style.scrollBehavior = "smooth";
      smoothScroll();
      document
        .querySelector(".scroll-panel")
        .scrollTo(0, document.querySelector("#" + id).offsetTop);
    } else if (getScreenWidth() < 992) {
      if (window.scrollY < 1) {
        window.scrollTo(0, 26);
        setTimeout(() => {
          scrollToElMobile();
        }, 500);
      } else {
        scrollToElMobile();
      }
    }
  };

  const clickclearAllFilter = () => {
    props.clearallfilter();
  };

  const searchItemMouseOver = (item) => {
    //console.log(item);
    setActiveItem(item);
  };

  return (
    <Fragment>
      {screenWidth < 992 && (
        <MapViewController
          clearAllFilter={clickclearAllFilter}
          triggerMapShow={mapController}
        />
      )}
      {isPogress && <Loader />}
      {!isPogress && (
        <div className="search-result-wrapper">
          <div className="row">
            <div className="col-lg-7 order-lg-1">
              <div
                className={`result-map ${
                  mapVisibility && screenWidth < 992 ? "show-device-map" : ""
                }`}
              >
                {displaystatus === 0 && (
                  <Map
                    rearchresults={resultObj}
                    onMarkerClick={scrollToEl}
                    mapVisibility={mapVisibility}
                  />
                )}
              </div>
            </div>
            <div className="col-lg-5">
              <div className="results-list">
                {screenWidth > 991.98 ? (
                  <Scrollbars
                    renderView={(props) => (
                      <div {...props} className="scroll-panel" />
                    )}
                    renderTrackVertical={(props) => (
                      <div {...props} className="track-vertical" />
                    )}
                    renderThumbVertical={(props) => (
                      <div {...props} className="thumb-vertical" />
                    )}
                  >
                    <ul>
                      {rearchresults.length > 0 &&
                        rearchresults.map((el, index) => (
                          <SearchItem
                            resourceItem={el}
                            itemIndex={index}
                          ></SearchItem>
                        ))}
                      {rearchresults.length === 0 && (
                        <li>{t("no_result_found")}</li>
                      )}
                    </ul>
                  </Scrollbars>
                ) : (
                  <ul>
                    {rearchresults.length > 0 &&
                      rearchresults.map((el, index) => (
                        <SearchItem
                          resourceItem={el}
                          itemIndex={index}
                        ></SearchItem>
                      ))}
                    {rearchresults.length === 0 && (
                      <li>{t("no_result_found")}</li>
                    )}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {!isPogress && <ScrollToTop></ScrollToTop>}
    </Fragment>
  );
};
export default Searchresult;
